import {
  Controller,
  Get,
  Post,
  Patch,
  Param,
  Body,
  UseGuards,
} from '@nestjs/common';
import { UsersService } from './users.service';
import { CreateUser, UpdateUser } from '@crm/dto';
import { ApiResponseInterface, UserRole } from '@crm/interface';
import { AuthGuard } from '../guards/auth.guard';
import { RolesGuard } from '../guards/roles.guard';
import { Roles } from '../guards/roles.decorator';

@Controller('users')
export class UsersController {
  constructor(private readonly usersService: UsersService) {}

  // ====== GET ALL USERS (management only) ======
  @Get()
  @UseGuards(AuthGuard, RolesGuard)
  @Roles(UserRole.MANAGEMENT)
  async getAll(): Promise<ApiResponseInterface> {
    return this.usersService.getAll();
  }

  // ====== GET USERS BY CREATOR/USER ID ======
  @Get('user/:userId')
  async getByUserId(@Param('userId') userId: string): Promise<ApiResponseInterface> {
    return this.usersService.getByUserId(userId);
  }

  // ====== GET USER BY ID ======
  @Get(':id')
  async getById(@Param('id') id: string): Promise<ApiResponseInterface> {
    return this.usersService.getById(id);
  }

  // ====== CREATE USER (management only) ======
  @Post()
  @UseGuards(AuthGuard, RolesGuard)
  @Roles(UserRole.MANAGEMENT)
  async create(@Body() dto: CreateUser): Promise<ApiResponseInterface> {
    return this.usersService.create(dto);
  }

  // ====== UPDATE USER ======
  @Patch()
  async update(@Body() dto: UpdateUser): Promise<ApiResponseInterface> {
    return this.usersService.update(dto);
  }

  // ====== SOFT DELETE USER (management only) ======
  @Patch('soft-delete')
  @UseGuards(AuthGuard, RolesGuard)
  @Roles(UserRole.MANAGEMENT)
  async softDelete(@Body() dto: UpdateUser): Promise<ApiResponseInterface> {
    return this.usersService.softDelete(dto);
  }
}
